/**
 * Toast Redux Reducer
 * 
 * Manages the queue of active toasts.
 * Toasts are stored in order of creation (oldest first).
 * When rendered, they stack from bottom to top (newest at bottom).
 */

import { types } from './toastTypes';
import { MAX_VISIBLE_TOASTS } from './toastConstants';

export const initialState = {
    toasts: [], // Array of toast objects
};

/**
 * Toast reducer
 * @param {Object} state - Current state
 * @param {Object} action - Redux action
 * @returns {Object} New state
 */
const toast = (state = initialState, { type, payload }) => {
    switch (type) {
    case types.SHOW_TOAST: {
        // Add new toast, limit to max visible
        const newToasts = [...state.toasts, payload];
        
        // If we exceed max, remove oldest toasts
        const trimmedToasts = newToasts.length > MAX_VISIBLE_TOASTS
            ? newToasts.slice(-MAX_VISIBLE_TOASTS)
            : newToasts;
            
        return {
            ...state,
            toasts: trimmedToasts,
        };
    }

    case types.DISMISS_TOAST:
        return {
            ...state,
            toasts: state.toasts.filter(t => t.id !== payload),
        };

    case types.DISMISS_ALL_TOASTS:
        return {
            ...state,
            toasts: [],
        };

    case types.UPDATE_TOAST: {
        const { id, updates } = payload;
        return {
            ...state,
            toasts: state.toasts.map(t => 
                t.id === id ? { ...t, ...updates } : t
            ),
        };
    }

    default:
        return state;
    }
};

export default toast;

